import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import RegisterView from "../views/RegisterView.vue";
import RequestPasswordChangeView from "../views/RequestPasswordChangeView.vue";
import ToolLayout from "../layouts/ToolLayout.vue";
import ShiftsView from "../views/ShiftsView.vue";
import ProfileView from "../views/ProfileView.vue";
import TeamsView from "../views/teams/TeamsView.vue";
import CreateTeamView from "../views/teams/CreateTeamView.vue";
import UpdateTeamView from "../views/teams/UpdateTeamView.vue";
import CreateTaskView from "../views/CreateTaskView.vue";
import UpdateTaskView from "../views/UpdateTaskView.vue";
import UsersView from "../views/UsersView.vue";
import CreateUserView from "../views/CreateUserView.vue";
import BroadcastSmsView from "../views/users/BroadcastSmsView.vue";
import BroadcastMailView from "../views/users/BroadcastMailView.vue";
import GuestsView from "../views/guests/IndexView.vue";
import CreateGuestView from "../views/guests/CreateView.vue";
import UpdateGuestView from "../views/guests/UpdateView.vue";
import ResetPasswordView from "../views/ResetPasswordView.vue";
import ReportPhoneListView from "../views/reports/PhoneListView.vue";
import ReportUsersWithShifts from "../views/reports/UsersWithShiftsView.vue";
import ReportShirts from "../views/reports/ShirtsView.vue";
import ReportCatering from "../views/reports/CateringView.vue";
import ReportUsersArrived from "../views/reports/UsersArrivedView.vue";
import WebhooksView from "../views/WebhooksView.vue";
import UpdateWebhookView from "../views/UpdateWebhookView.vue";
import ApikeysView from "../views/apikeys/IndexView.vue";
import EventsView from "../views/events/EventsView.vue";
import UpdateEventView from "../views/events/UpdateEventView.vue";
import CreateEventView from "../views/events/CreateEventView.vue";
import TicketTemplatesView from "../views/../views/ticket_templates/IndexView.vue";
import CreateTicketTemplateView from "../views/ticket_templates/CreateView.vue";
import UpdateTicketTemplateView from "../views/ticket_templates/UpdateView.vue";
import ConfirmView from "../views/ConfirmView.vue";
import ConfirmEmailView from "../views/ConfirmEmailView.vue";
import UserView from "../views/UserView.vue";
import ConnectUserView from "../views/events/ConnectUserView.vue";
import ReceptionView from "../views/ReceptionView.vue";
import ReportTickets from "../views/reports/TicketsView.vue";
import UpdateConfigView from "../views/UpdateConfigView.vue";
import ApiShiftsView from "../views/ApiShiftsView.vue";
import BadgeExportView from "../views/events/BadgeExports.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      component: ToolLayout,
      path: "/",
      children: [
        {
          path: "",
          name: "home",
          component: HomeView,
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: LoginView,
    },
    {
      path: "/register",
      name: "register",
      component: RegisterView,
    },
    {
      path: "/confirm",
      name: "confirm",
      component: ConfirmView,
    },
    {
      path: "/confirmEmail",
      name: "confirmEmail",
      component: ConfirmEmailView,
    },
    {
      path: "/requestpasswordchange",
      component: RequestPasswordChangeView,
    },
    {
      path: "/resetpassword",
      component: ResetPasswordView,
    },
    {
      path: "/shifts",
      component: ToolLayout,
      children: [
        {
          path: "",
          component: ShiftsView,
        },
        {
          path: "/reception",
          name: "reception",
          component: ReceptionView,
        },
      ],
    },
    {
      path: "/reports",
      component: ToolLayout,
      children: [
        {
          path: "phones",
          component: ReportPhoneListView,
        },
        {
          path: "userswithshifts",
          component: ReportUsersWithShifts,
        },
        {
          path: "shirts",
          component: ReportShirts,
        },
        {
          path: "arrived",
          component: ReportUsersArrived,
        },
        {
          path: "tickets",
          component: ReportTickets,
        },
      ],
    },
    {
      path: "/events",
      component: ToolLayout,
      children: [
        {
          path: "",
          component: EventsView,
        },
        {
          path: "create",
          component: CreateEventView,
        },
        {
          path: ":event",
          component: UpdateEventView,
        },
        {
          path: ":event/ticketTemplates",
          component: TicketTemplatesView,
        },
        {
          path: ":event/ticketTemplates/create",
          component: CreateTicketTemplateView,
        },
        {
          path: ":event/ticketTemplates/create/:id",
          component: CreateTicketTemplateView,
        },
        {
          path: ":event/ticketTemplates/:id",
          component: UpdateTicketTemplateView,
        },
        {
          path: ":event/badges",
          component: BadgeExportView,
        },
        {
          path: ":event/guest",
          component: GuestsView,
        },
        {
          path: ":event/guest/create",
          component: CreateGuestView,
        },
        {
          path: ":event/guest/:id",
          component: UpdateGuestView,
        },
        {
          path: ":event/connect/:user/:ticket",
          component: ConnectUserView,
        },
        {
          path: ":event/reports/catering",
          component: ReportCatering,
        },
      ],
    },
    {
      path: "/settings",
      component: ToolLayout,
      children: [
        {
          path: "webhook",
          component: WebhooksView,
        },
        {
          path: "webhook/:id",
          component: UpdateWebhookView,
        },
        {
          path: "apikey",
          component: ApikeysView,
        },
        {
          path: "config",
          component: UpdateConfigView,
        },
      ],
    },
    {
      path: "/user",
      component: ToolLayout,
      children: [
        {
          path: "me",
          component: ProfileView,
        },
        {
          path: "",
          component: UsersView,
        },
        {
          path: "broadcast",
          component: BroadcastSmsView,
        },
        {
          path: "broadcast/mail",
          component: BroadcastMailView,
        },
        {
          path: "new",
          component: CreateUserView,
        },
        {
          path: ":id",
          component: UserView,
        },
        {
          path: ":id/connect/:ticket",
          component: ConnectUserView,
        },
      ],
    },
    {
      path: "/teams",
      component: ToolLayout,
      children: [
        {
          path: "",
          component: TeamsView,
        },
        {
          path: ":event/create",
          component: CreateTeamView,
        },
        {
          path: ":event/:team",
          component: UpdateTeamView,
        },
        {
          path: ":event/:team/create",
          component: CreateTaskView,
        },
        {
          path: ":event/:team/create/:task",
          component: CreateTaskView,
        },
        {
          path: ":event/:team/update/:task",
          component: UpdateTaskView,
        },
      ],
    },
    {
      path: "/extern/shifts/:token",
      component: ApiShiftsView,
    },
  ],
});

export default router;
